module.exports = __webpack_public_path__ + "static/media/work-img3.9d4f7276.jpg";